import axios from 'axios';

export default {

  generate(projectId, version) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/generations`;
    return axios.post(url, {"version": version});
  },

}